import React, {Fragment} from 'react';
import { ClickAndReveal, Intro, Voiceover} from 'abbot-core';
import img1 from '../../assets/images/U1-T2-2-2a.svg';
import img2 from '../../assets/images/U1-T2-2-2b.svg';
import img3 from '../../assets/images/U1-T2-2-2c.svg';
import img4 from '../../assets/images/U1-T2-2-2d.svg';
import img5 from '../../assets/images/U1-T2-2-2e.svg';
import img6 from '../../assets/images/U1-T2-2-2f.svg';
import voAudio from '../../assets/vo/U1-T2-2-2.mp3';

const data = [
  {
    x: 21,
    y: 69,
    name: 'Vegetables',
    modal: {
      title: 'Vegetables',
      text: 'Most vegetables contain key nutrients your body needs to stay healthy. These nutrients include important vitamins such as Vitamin A for healthy eyes and skin. Vitamin C is important for the health of your organs and other body parts, can help your body heal from cuts and wounds, and can keep your gums healthy, too. Choosing vegetables as part of your nutritious food choices can help reduce the risk of developing certain noncommunicable diseases.',
      image: img2,
      imageText: 'Vegetables'
    }
  },
  {
    x: 10,
    y: 5,
    name: 'Fruits',
    modal: {
      title: 'Fruits',
      text: 'Fruits provide a great source of vitamin C and other essential nutrients to keep your body healthy today and in the future. For example, many people don’t get enough daily potassium, which can help keep blood within a healthy range. One small banana has enough potassium to be a nutritious choice for a daily snack. Not a fan of bananas? There are other great fruit choices you can make instead, like oranges and melon.',
      image: img3,
      imageText: 'Fruits'
    }
  },
  {
    x: 67,
    y: 22,
    name: 'Grains',
    modal: {
      title: 'Grains',
      text: 'Any type of food made from wheat, barley, oats, cornmeal, rice, or other cereal grains is a grain product. Grains are a large part of most people’s diet because grain products include foods like bread, tortillas, grits, pasta, oatmeal, and breakfast cereals. Grains are an important part of a healthy diet. They can help people maintain a healthy weight and as part of a healthy diet, can help reduce the risk of developing heart disease. It’s best to pick whole grains when you can, so you can benefit from the fiber, B vitamins, and iron.',
      image: img4,
      imageText: 'Grains'
    }
  },
  {
    x: 70,
    y: 87,
    name: 'Protein',
    modal: {
      title: 'Protein',
      text: 'Protein is an important source of fuel for your body, especially when it comes to your bones and muscles. Beef, pork, poultry, fish, and eggs are likely the most familiar to you. But beans, nuts, and some seeds like sunflower or pumpkin, are also excellent sources of protein. Certain meats have more saturated, or unhealthy, fat than others. Eating too much of this type of fat can contribute to certain NCDs, so it’s best to pick lean meats when you can.',
      image: img5,
      imageText: 'Protein'
    }
  },
  {
    x: 87,
    y: 58,
    name: 'Dairy',
    modal: {
      title: 'Dairy',
      text: 'Strong bones and teeth rely on calcium and other ingredients found in dairy products. Milk is the most familiar dairy product, but cheese and yogurt are two other dairy products that a lot of people like to eat. Along with calcium for strong bones and teeth, dairy products have key nutrients such as vitamin D, potassium, and protein.',
      image: img6,
      imageText: 'Dairy'
    }
  },
];

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      The United States Department of Agriculture has a suggested set of dietary guidelines called MyPlate. This is a program that identifies the different food groups and offers recommendations on the amount of each food group people should eat each day. Click on each group to learn more.
    </p>
  )
};

export default {
  title: 'Nutritious Food Choices',
  path: '/learn/nutritious-food-choices',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      
      <Intro
        title="My Plate"
        lead="The MyPlate program shows you the different food groups and how much of each you should try to eat every day."
        direction="Select each hotspot to learn more."
      />
      
      <ClickAndReveal
        data={data}
        backgroundImage={img1}
        backgroundImageText='My Plate'
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/learn/NutritiousFoodChoices.js